import React from "react";
import SectionTemplate from "../../SectionTemplate";
import { useState, useRef, useEffect, useLayoutEffect } from "react";
import CircledNumber from "../../CircledNumber";
import axios from "../../../utils/fvAxios";
import IntroductionHtmlContext from "./IntroductionHtmlContext";
import useFetch from "../../../utils/useFetch";
import BaseURL from "../../../utils/base-uri.json";

import _ from "lodash";
import { Box, CircularProgress } from "@mui/material";
import Button from "../../../toolkit/ButtonV1";
import ErrorAlert from "../../../toolkit/ErrorAlert";
import saveData from "../../../utils/saveData";
import LoadingSpinner from "../../../toolkit/LoadingSpinner";
import { getOrgType } from "../../../utils/Token";

export default function Introduction({
  Secid,
  selected,
  SectionType,
  setNextSection,
  IsSectionCompleted,
}) {
  function getQuestionNavOptions({ id, text, status }, idx) {
    return {
      id,
      text,
      status,
      leadingComponent: <CircledNumber num={idx + 1} />,
    };
  }

  const [question, setQuestion] = useState();
  const [questions, setPqlocations] = useState([]);
  const [refreshQuestion, setRefreshQuestion] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const PQID = params.get("pqid");

  const {
    data: resp,
    loading,
    error,
  } = useFetch(
    BaseURL.baseUrl +
    "Prequalification/SectionOrSubSectionDetails?pqId=" +
    PQID +
    "&sectionId=" +
    Secid +
    "&sectionType=" +
    SectionType
  );

  // const [disabledButtons, setDisabledButtons] = useState({
  //   prev: true,
  //   next: true,
  // });
  const [scrollTabIntoView, setScrollTabIntoView] = useState(false);

  useLayoutEffect(() => {
    if (scrollTabIntoView) {
      const questionIds = (questions || []).map((f) => f.id);
      const idx = questionIds?.indexOf(question?.id);
      questionTabsRef?.current?.children[idx]?.scrollIntoView();
      setScrollTabIntoView(false);
    }
  }, [question, scrollTabIntoView]);

  // function setPrevActive() {
  //   const cur = questions?.find((f) => f.id === question.id);
  //   const prev = questions[questions?.indexOf(cur) - 1];
  //   if (prev) {
  //     setScrollTabIntoView(true);
  //     setQuestionId(prev.id);
  //   }
  // }

  function setNextActive() {
    const cur = questions?.find((f) => f.id === question.id);
    const next = questions[questions?.indexOf(cur) + 1];
    if (next) {
      setScrollTabIntoView(true);
      setQuestionId(next.id);
    } else {
      setNextSection();
    }
  }


  useEffect(() => {
    if (resp?.data) {
      // const statusresponse =resp?.data?.isSectionCompleted

      // setPqlocations(resp?.data?.clientProfiles?.map((r, index) => ({
      //   id: index,
      //   text: r.positionTitle,
      //   status: statusresponse==true ? "completed" : "pending",
      //   positionContent: r.positionContent,
      //   documents: r.documents,
      // })
      // ));


      const statusresponse = resp?.data?.isSectionCompleted;

      setPqlocations(
        resp?.data?.clientProfiles?.reduce((accumulator, current, index) => {
          if (current.positionTitle === null) {
            if (accumulator.length === 0) {
              accumulator.push({
                id: index,
                text: null,
                status: statusresponse === true ? "completed" : "pending",
                positionContent: current.positionContent,
                documents: current.documents,
              });
            } else {
              accumulator[accumulator.length - 1].positionContent += current.positionContent;
            }
          } else {
            accumulator?.push({
              id: index,
              text: current.positionTitle,
              status: statusresponse === true ? "completed" : "pending",
              positionContent: current.positionContent,
              documents: current.documents,
            });
          }

          return accumulator;
        }, [])
      );
      // if (SectionType == 31) {
      //   axios
      //     .get("Prequalification/GetPQBusinessUnitDocuments?pqId=" + PQID)
      //     .then((res) => {

      //       if (res?.data?.data?.docs?.buSites?.length > 0) {
      //         setPqlocations((prevLocations) => {
      //           if (prevLocations?.some(location => location.buData !== undefined)) {
      //             return prevLocations;
      //           }
      //           const updatedLocations = [
      //             ...prevLocations,
      //             {
      //               id: resp?.data?.clientProfiles?.length ?? 0,
      //               text: "Downloads",
      //               status: statusresponse == true ? "completed" : "pending",
      //               positionContent: null,
      //               documents: null,
      //               buData: res?.data?.data,
      //             },
      //           ];
      //           return updatedLocations;
      //         });
      //       }
      //     });
      // }
    }
  }, [resp]);
  const questionTabsRef = useRef(null);
  const [questionId, setQuestionId] = useState(selected);
  const [questionNavProps, setQuestionNavProps] = useState({
    options: questions?.map(getQuestionNavOptions),
    onChange: setQuestionId,
    refFromParent: questionTabsRef,
  });

  useEffect(() => {
    setQuestionNavProps((prev) => ({
      ...prev,
      options: questions?.map(getQuestionNavOptions),
    }));
    setQuestionId(questions?.[0]?.id);
    setRefreshQuestion({});
  }, [questions]);

  useEffect(() => {
    setQuestion(questions?.find((s) => s.id === questionId));
    // setDisabledButtons({
    //   prev: questionId <= 0,
    //   next: questionId > questions?.length - 1,
    // });
  }, [questionId, refreshQuestion]);

  function onSave() {
    (async () => {
      const details = {
        pqId: +PQID, //TODO:-- Convert String to Integer
        templateSecId: Secid,
        isSectionCompleted: IsSectionCompleted,
        sectionType: SectionType,
      };
      const data = await axios.post(
        "Prequalification/AddCompletedSubSectionForPQ",
        details
      );
      if (data.data.data == "Success") {
        setNextSection(true);
      }
    })();
  }

  return (
    <>

      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <ErrorAlert severity="error" message={error} />
      ) : (
        <SectionTemplate
          className="questionnaire-template"
          IsSectionCompleted={IsSectionCompleted}
          navProps={{
            ...questionNavProps,
            selected: questionId,
          }}
        >
          <IntroductionHtmlContext section={question} />

          {question ? (
            <Box className="questionnaire-template-buttons buttons">
              {/* <Button
                role="primary"
                size="small"
                label="Previous"
                onClick={setPrevActive}
                hidden={disabledButtons.prev}
              /> */}

              <Box flexGrow={1} />
              {getOrgType() == "Client" ?
              <>
                <Button
                  role="primary"
                  size="small"
                  label="Continue"
                  onClick={setNextActive}
                  hidden={questions[questions?.length - 1]?.id != questionId}
                />
                 <Button
                role="primary"
                size="small"
                label="Continue"
                onClick={setNextActive}
                hidden={questions[questions?.length - 1]?.id == questionId}
  
              />
                </>
                :
                <>   <Button
                role="primary"
                size="small"
                label="Complete & Continue"
                onClick={onSave}
                hidden={questions[questions?.length - 1]?.id != questionId}
              />   <Button
                role="primary"
                size="small"
                label="Continue"
                onClick={setNextActive}
                hidden={questions[questions?.length - 1]?.id == questionId}
  
              /></>
              
                
              }
              <Box flexGrow={1} />


          
            </Box>
          ) : (
            <ErrorAlert severity="warning" message="Nothing to show!" />
          )}
        </SectionTemplate>
      )}
    </>
  );
}
